import firebase from "firebase";
const PaymentService = {
  getPayment(mid) {
    return firebase.database().ref(`member_payment/${mid}`);
  },
};

export default PaymentService;
